import ActionDropdown from '@app/components/common/ActionDropdown';
import Box from '@app/components/common/Box';
import Button from '@app/components/common/Button';
import Icon from '@app/components/common/Icon';
import ThreeDots from '@app/components/common/Icon/custom/ThreeDots';
import LayoutGrid from '@app/components/LoggedIn/Home/DashboardCreator/LayoutGrid/LayoutGrid';
import {
  CUSTOM_REPORT_NUMBER_OF_COLUMNS,
  CUSTOM_REPORT_ROW_SIZE,
} from '../types';

const separation = 15;

interface IPage {
  index: number;
  showGridLines: boolean;
  onRemovePage: (index: number) => void;
  pageSize: number;
}
const Page = ({ index, showGridLines, onRemovePage, pageSize }: IPage) => {
  return (
    <Box
      csx={{
        position: 'absolute',
        height: pageSize - separation,
        top: (pageSize - separation) * index + separation * index,
        width: 'inherit',
      }}
      key={`layoutGrid-${index}`}>
      <LayoutGrid
        height={pageSize - separation}
        columns={CUSTOM_REPORT_NUMBER_OF_COLUMNS}
        squareSize={CUSTOM_REPORT_ROW_SIZE}
        showGridLines={showGridLines}
        showBorder
      />
      <Box
        className="pageOptions"
        csx={{
          position: 'absolute',
          top: 10,
          right: 15,
          zIndex: 1,
        }}>
        <ActionDropdown
          trigger={
            <Button
              variant="icon"
              csx={{
                ':hover': {
                  backgroundColor: '#f4f4f4',
                  borderRadius: '50%',
                },
              }}
              icon={<ThreeDots color="black" />}
            />
          }>
          <ActionDropdown.Item
            icon={<Icon name="MdDeleteForever" color="error" />}
            csx={theme => ({
              color: `${theme.colors.semanticRed} !important`,
              svg: {
                fill: `${theme.colors.semanticRed} !important`,
              },
            })}
            onClick={() => {
              onRemovePage(index + 1);
            }}>
            Remove Page
          </ActionDropdown.Item>
        </ActionDropdown>
      </Box>
    </Box>
  );
};

export default Page;
